function isIOS() {
  return /iPad|iPhone|iPod/.test(window?.navigator?.userAgent)
}
function isAndroid() {
  return /Android/.test(window?.navigator?.userAgent)
}

function isWebView() {
  const ua = navigator.userAgent || ''

  // 1. React Native WebView
  const isReactNativeWV = ua.includes('ReactNative') || ua.includes(' wv')

  // 2. iOS WKWebView
  const isIOSWV = /iPhone|iPad|iPod/.test(ua) && !/Safari/.test(ua)

  // 3. Android Native WebView
  const isAndroidWV =
    ua.toLowerCase().includes('wv') || ua.toLowerCase().includes('version/4.0')

  return isReactNativeWV || isIOSWV || isAndroidWV
}

export { isAndroid, isIOS, isWebView }
